import * as React from 'react'
import { NoteMessage } from './NoteMessage'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NoteMessageExamples = () => {
  return (
    <div className="NoteMessageExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NoteMessage />
      </Provider>
    </div>
  )
}
